import React, { useContext } from 'react'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import { SEARCH_FLIGHTS_COPY, VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import useDeepLinkButtonProps from 'tripPlanner/hooks/useDeepLinkButtonProps'
import { LETripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: LETripItem
  className?: string
}

function DeepLinkButtons({ item, className }: Props) {
  const tripContext = useContext(TripContext)
  const curatedTripId = tripContext?.viewAsTemplate
    ? tripContext.tripId
    : undefined
  const canEdit = tripContext?.permissions.canEdit ?? false

  const { onClick, deepLinkUrl, label, productLink } = useDeepLinkButtonProps(
    item,
    curatedTripId,
  )

  const viewCopy =
    item.type === 'FLIGHT' ? SEARCH_FLIGHTS_COPY : VIEW_OFFER_COPY

  return (
    <Group
      direction="horizontal"
      className={className}
      verticalAlign="center"
      horizontalAlign="space-between"
      gap={12}
    >
      <TextButton
        kind={canEdit ? 'secondary' : 'primary'}
        to={productLink}
        onClick={onClick}
      >
        {viewCopy}
      </TextButton>
      {canEdit && deepLinkUrl && (
        <TextButton kind="primary" to={deepLinkUrl} onClick={onClick}>
          {label}
        </TextButton>
      )}
    </Group>
  )
}

export default React.memo(DeepLinkButtons)
